export default {"src":"/_next/static/image/public/images/ajax-loader.fb6f3c230cb846e25247dfaa1da94d8f.gif","height":32,"width":32};